<template>
  <div class="container">
    <b-card
      title="Data Selection"
      class="margin-bottom"
      v-if="lookups && dataSelection"
    >
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Tier">
            <b-form-checkbox-group
              button-variant="primary"
              v-model="selectedTiers"
              :options="tiers"
              name="buttons-1"
              buttons
              text-field="name"
              value-field="id"
              @change="tierChange"
            ></b-form-checkbox-group>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Regions">
            <multiselect
              v-model="dataSelection.regions"
              tag-placeholder="Add this as new tag"
              placeholder="Search or add a tag"
              label="name"
              track-by="id"
              :options="regions"
              :multiple="true"
              :hide-selected="true"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Postcodes">
            <b-input-group>
                <div class="multiselect-wrapper">
                  <multiselect
                    v-model="dataSelection.postcodeAreas"
                    placeholder="Search"
                    label="name"
                    track-by="areaCode"
                    :options="postcodes"
                    :multiple="true"
                    :hide-selected="true"
                  ></multiselect>            
                </div>
                  <b-dropdown
                    size="lg"
                    variant="outline"
                    toggle-class="text-decoration-none p-1"
                    menu-class="flag-menu"
                    right
                  >
                    <template #button-content>
                      <flag v-if="selectedCountryCode === 'gb'" iso="gb" />
                      <flag v-else-if="selectedCountryCode === 'ie'" iso="ie" />
                    </template>
                    <b-dropdown-item class="flag-item" @click="getPostcodes('gb')">
                      <flag iso="gb" />
                    </b-dropdown-item>
                    <b-dropdown-item class="flag-item" @click="getPostcodes('ie')">
                      <flag iso="ie" class="fs-1"/>
                    </b-dropdown-item>
                  </b-dropdown>                  
              </b-input-group>            
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Sectors">
            <multiselect
              v-model="dataSelection.sectors"
              tag-placeholder="Add this as new tag"
              placeholder="Search or add a tag"
              label="name"
              track-by="id"
              :options="lookups.sectors"
              :multiple="true"
              :hide-selected="true"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Sub Sectors">
            <multiselect
              v-model="dataSelection.subSectors"
              tag-placeholder="Add this as new tag"
              placeholder="Search or add a tag"
              label="name"
              track-by="id"
              :options="subSectors"
              :multiple="true"
              :hide-selected="true"
            ></multiselect>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Campaigns">
            <multiselect
              v-model="dataSelection.campaigns"
              tag-placeholder="Add this as new tag"
              placeholder="Search or add a tag"
              label="campaignName"
              track-by="campaignId"
              :options="lookups.campaigns"
              :multiple="true"
              :hide-selected="true"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Marketing Tags">
            <multiselect
              v-model="dataSelection.marketingTags"
              tag-placeholder="Add this as new tag"
              placeholder="Search or add a tag"
              label="marketingTagName"
              track-by="marketingTagId"
              :options="lookups.marketingTags"
              :multiple="true"
              :hide-selected="true"
            ></multiselect>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <b-form-group label="Employees Min">
            <b-form-input v-model="dataSelection.userDataFilter.employeesMin" type="number"
                          ></b-form-input>
                      <b-alert show v-if="validationMin" variant="danger">
                        {{ validationMin }}
                      </b-alert>
                      

          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Max">
            <b-form-input v-model="dataSelection.userDataFilter.employeesMax" type="number"
                          ></b-form-input>
                        <b-alert show v-if="validationMax" variant="danger">
                        {{ validationMax }}
                      </b-alert>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Year End">
            <b-form-select :options="months"
                           v-model="dataSelection.userDataFilter.yearEnd">
              <template v-slot:first>
                <b-form-select-option :value="null">-</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Not contacted in the last">
            <b-form-radio
              v-model="selectedContactRange"
              name="some-radios"
              value="not3Month"
              @change="contactChange"
              >3 months</b-form-radio
            >
            <b-form-radio
              v-model="selectedContactRange"
              name="some-radios"
              value="not6Month"
              @change="contactChange"
              >6 months</b-form-radio
            >
            <b-form-radio
              v-model="selectedContactRange"
              name="some-radios"
              value="not12Month"
              @change="contactChange"
              >12 months</b-form-radio
            >
            <b-form-radio
              v-model="selectedContactRange"
              name="some-radios"
              value="notEver"
              @change="contactChange"
              >Ever</b-form-radio
            >
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Any contact in the last">
            <b-form-radio
              v-model="selectedContactRange"
              name="some-radios"
              value="contact3Month"
              @change="contactChange"
              >3 months</b-form-radio
            >
            <b-form-radio
              v-model="selectedContactRange"
              name="some-radios"
              value="contact6Month"
              @change="contactChange"
              >6 months</b-form-radio
            >
            <b-form-radio
              v-model="selectedContactRange"
              name="some-radios"
              value="contact12Month"
              @change="contactChange"
              >12 months</b-form-radio
            >
            <b-form-radio
              v-model="selectedContactRange"
              name="some-radios"
              value="contactEver"
              @change="contactChange"
              >Ever</b-form-radio
            >
          </b-form-group>
        </div>
      </div>

      <!-- <div class="row">
        <b-button type="reset" variant="info">
          <font-awesome-icon icon="eraser" /> Cancel
        </b-button>
        <b-button type="button" variant="light">
          <font-awesome-icon icon="download" /> Save
        </b-button>
      </div> -->

      <div class="row justify-content-center mb-2">
        <b-button type="reset" variant="info"  class="margin-right" @click="clear">
          <font-awesome-icon icon="eraser" /> Clear Selection
        </b-button>

        <FeedbackButton title="Save and Count" icon="list-ol" :busy="isCountBusy" :onClick="count" class="margin-right" :disabled="!dataSelection || !dataSelection.tiers || dataSelection.tiers.length == 0 || isCallBusy"/>

        <FeedbackButton title="Start Call List" icon="phone" :busy="isCallBusy" :onClick="startCall" class="margin-right" :disabled="!dataSelection || !dataSelection.tiers || dataSelection.tiers.length == 0 ||  !currentCount || currentCount == 0 || isCountBusy"/>

      </div>
      <b-alert show v-if="currentCount != null" class="margin-top"><strong>Companies Found: </strong>{{currentCount}}</b-alert>
      <div class="row justify-content-center">
        <b-alert variant="info" show>Republic of Ireland records will be hidden unless selected by Region or Postcode</b-alert>
      </div>
      
      <Feedback ref="feedback"/>
    </b-card>
  </div>
</template>

<script>
import LookupsService from "@/services/Lookups.service";
import DataSelectionService from "@/services/DataSelection.service";
import FeedbackButton from "@/components/shared/FeedbackButton.vue";
import Feedback from "@/components/shared/Feedback.vue";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect, FeedbackButton, Feedback },
  created() {
    //this.loadData();

    LookupsService.loadLookups().then((result) => {
      this.lookups = result.data;
    });

    this.getPostcodes('gb');

    LookupsService.loadRegions().then((result) => {
      this.regions = result.data;
    });

    DataSelectionService.getDataSelection().then((result) => {
      this.dataSelection = result.data;

      if (!this.dataSelection.userDataFilter) return;

      this.selectedContactRange == null;
      this.selectedTiers = this.dataSelection.tiers;

      if (this.dataSelection.userDataFilter.filterNotContacted3Months) this.selectedContactRange = "not3Month";
      if (this.dataSelection.userDataFilter.filterNotContacted6Months) this.selectedContactRange = "not6Month";
      if (this.dataSelection.userDataFilter.filterNotContacted12Months) this.selectedContactRange = "not12Month";
      if (this.dataSelection.userDataFilter.filterNotContactedEver) this.selectedContactRange = "notEver";
      if (this.dataSelection.userDataFilter.filterContacted3Months) this.selectedContactRange = "contact3Month";
      if (this.dataSelection.userDataFilter.filterContacted6Months) this.selectedContactRange = "contact6Month";
      if (this.dataSelection.userDataFilter.filterContacted12Months) this.selectedContactRange = "contact12Month";
      if (this.dataSelection.userDataFilter.filterContactedEver) this.selectedContactRange = "contactEver";


    });
  },
  watch: {
    lookups: {
      handler: function () {
        this.filterSubSectors();
      },
      deep: true,
    },
    "dataSelection.sectors": {
      handler: function () {

        if (!this.lookups) return;
        this.filterSubSectors();
      },
      deep: true,
    }
  },
  data() {
    return {
      dataSelection: null,
      lookups: null,
      postcodes: [],
      regions: [],
      selected: [],
      selectedRegions: [],
      selectedSectors: [],
      selectedSubSectors: [],
      selectedPostcodes: [],
      selectedCampaigns: [],
      selectedMarketingTags: [],
      selectedContactRange: "not6Month",
      selectedTiers: [],
      tiers: [
        { id: -1, name: "All" },
        { id: 0, name: "Unclassified" },
        { id: 110, name: "Platinum" },
        { id: 30, name: "Gold" },
        { id: 20, name: "Silver" },
        { id: 10, name: "Bronze" },
      ],
      subSectors:[],
      currentCount: null,
      isCountBusy:false,
      isCallBusy: false,
      employeeOptions: [],
      months: [
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" }],
      validationMin: null,
      validationMax: null,
    };
  },
  methods: {
    filterSubSectors() {

      if(!this.dataSelection || !this.lookups) return;

        this.subSectors = this.lookups.subSectors.filter((x) =>
            this.dataSelection.sectors.some((y) => y.id == x.sectorId)
        );

        if( this.dataSelection.subSectors) {

          this.dataSelection.subSectors = this.dataSelection.subSectors.filter(
            (x) => this.dataSelection.sectors.some((y) => y.id == x.sectorId)
          );
      }

    },
    contactChange(value) {

      this.dataSelection.userDataFilter.filterContacted3Months = value == "contact3Month";
      this.dataSelection.userDataFilter.filterContacted6Months = value == "contact6Month";
      this.dataSelection.userDataFilter.filterContacted12Months = value == "contact12Month";
      this.dataSelection.userDataFilter.filterContactedEver = value == "contactEver";

      this.dataSelection.userDataFilter.filterNotContacted3Months = value == "not3Month";
      this.dataSelection.userDataFilter.filterNotContacted6Months = value == "not6Month";
      this.dataSelection.userDataFilter.filterNotContacted12Months = value == "not12Month";
      this.dataSelection.userDataFilter.filterNotContactedEver = value == "notEver";
      console.log(this.dataSelection.userDataFilter.filterContacted3Months, value, value == "contact3Month", this.dataSelection.userDataFilter)
    },
    count() {
      if (this.validateEmployees()){
        this.isCountBusy = true;
        DataSelectionService.saveAndCount(this.dataSelection).then((result) => {
          this.currentCount = result.data;          
          this.isCountBusy = false;
        }).catch(() => {
          this.isCountBusy = false;
          this.$refs.countFeedback.showError("Error Calling count");
        });
      }
      
    },
    startCall() {
      this.isCallBusy = true;
      DataSelectionService.startCall(this.dataSelection).then(() => {
        this.isCallBusy = false;
        this.$router.push("/getnext");
      }).catch(() => {
        this.isCallBusy = false;
        this.$refs.countFeedback.showError("Error populating call list");
      });
    },
    tierChange(value) {
      console.log(this.selectedTiers);
      if (value.includes(-1) && !this.selectedTiers.includes(-1)) {
        console.log("All Added");
        this.selectedTiers = [110, 30, 20, 10, 0, -1];
        this.dataSelection.tiers = [110, 30, 20, 10, 0];
      }
      else if (!value.includes(-1) && this.selectedTiers.includes(-1)) {
        console.log("All Removed");
        this.selectedTiers = [];
        this.dataSelection.tiers = [];
      }
      else {
        this.dataSelection.tiers = value.filter(x => x != -1);
      }
      
    },
    validateEmployees(){
      this.validationMin = null;
      this.validationMax = null;
      if(this.dataSelection.userDataFilter.employeesMin == "" && this.dataSelection.userDataFilter.employeesMax == ""){        
          return true;
      }else if (this.dataSelection.userDataFilter.employeesMin != "" && this.dataSelection.userDataFilter.employeesMax != ""){
        if(Number(this.dataSelection.userDataFilter.employeesMin) <= Number(this.dataSelection.userDataFilter.employeesMax)){
          return true;
        }else{
          this.validationMax = 'Must be greater than the min value'
          return false;
        }
      } else if (this.dataSelection.userDataFilter.employeesMin == ""){
        this.validationMin = 'Please enter a valid min value';
        return false;
      }else if (this.dataSelection.userDataFilter.employeesMax == ""){
        this.validationMax = 'Please enter a valid max value';
        return false;
      }
      return false;
    },
    clear() {
      this.selectedContactRange = "not6Month";
      this.dataSelection.tiers = [];
      this.selectedTiers = [];
      this.dataSelection.regions = [];
      this.dataSelection.postcodeAreas = [];
      this.dataSelection.sectors = [];
      this.dataSelection.subSectors = [];
      this.dataSelection.campaigns = [];
      this.dataSelection.marketingTags = [];

      this.dataSelection.userDataFilter.yearEnd = null;
      this.dataSelection.userDataFilter.employeesMin = ""; 
      this.dataSelection.userDataFilter.employeesMax = "";   
      this.dataSelection.userDataFilter.filterNotContacted3Months = false;
      this.dataSelection.userDataFilter.filterNotContacted6Months = true;
      this.dataSelection.userDataFilter.filterNotContacted12Months = false;
      this.dataSelection.userDataFilter.filterNotContactedEver = false;
      this.dataSelection.userDataFilter.filterContacted3Months = false;
      this.dataSelection.userDataFilter.filterContacted6Months = false;
      this.dataSelection.userDataFilter.filterContacted12Months = false;
      this.dataSelection.userDataFilter.filterContactedEver = false;

      this.currentCount = 0
    }, 
    getPostcodes(countryCode){
      if (countryCode != this.selectedCountryCode){
        this.selectedCountryCode = countryCode;
        LookupsService.loadPostcodeArea(countryCode).then(result => {
          this.postcodes = result.data;
          if(this.dataSelection){
            this.dataSelection.postcodeAreas = [];
          }
          
        })
      }
    }
  },
};
</script>
<style scoped>
  .multiselect-wrapper .multiselect {
    width: 100% !important;   /* force it to fill the row */
  }
  .multiselect-wrapper .multiselect__tags {
    min-height: calc(2.25rem + 2px);
    display: flex;
    align-items: center;
  }
  .multiselect-wrapper {
    flex: 1 1 auto;
    min-width: 0;
  }
  .multiselect-wrapper .multiselect__tags {
    width: 100%;
    box-sizing: border-box;
  }
  .multiselect-wrapper .multiselect {
    width: 100%;
    max-width: 100%;
  }
</style>
